import * as _ from 'lodash-es';
import { MAT_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Component, OnInit, ChangeDetectionStrategy, inject as inject_1 } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, MatIcon]
})
export class AlertComponent implements OnInit {
    protected _options = inject_1(MAT_SNACK_BAR_DATA);


    get classes(): any {
        return {
            success: this.options.success || false,
            error: this.options.error || false,
            'alert-text': true
        };
    }

    get options(): any {
        return this._options || {};
    }

    ngOnInit(): void { }

    isMessage(): boolean {
        return !this.isSuccess() && !this.isError();
    }

    isSuccess(): boolean {
        return this.options.success === true;
    }

    isError(): boolean {
        return this.options.error === true;
    }

    inject() {
        return _.template(this.options.message)(this.options || {});
    }

}
